import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';
import { client } from 'hooks/use-ky';

import { EnumResult, getEnumsInput, NotificationBadges } from './model';

export function useGetEnums(
  input?: getEnumsInput,
  options?: UseQueryOptions<ExtendedApiResult<EnumResult[]>, ApiError>,
) {
  return useQuery<ExtendedApiResult<EnumResult[]>, ApiError>(
    ['getEnums', input?.class],
    () =>
      QueryFetchFunction({
        url: `enums/${input?.class}`,
      }),
    options,
  );
}

export const getCSRF = async function (): Promise<string[]> {
  const response = await client
    .get('/api/csrf-cookie', {
      prefixUrl: '',
    })
    .json<any>();
  return response.data;
};

export function useGetNotificationBadges(
  options?: UseQueryOptions<ApiResult<NotificationBadges>, ApiError>,
): UseQueryResult<ApiResult<NotificationBadges>, ApiError> {
  return QueryTransformer(
    useQuery<ApiResult<NotificationBadges>, ApiError>(
      ['getNotificationBadges'],
      () =>
        QueryFetchFunction({
          url: 'notification-badges',
        }),
      options,
    ),
    NotificationBadges,
  );
}

export function getNotificationBadgesKey() {
  const keys: any[] = ['getNotificationBadges'];
  return keys;
}
